/** Mirrors web/src/common/utils/business-days.ts — patients/clinics may not
 *  book a rental start sooner than 3 business days out (server re-enforces). */
export const RENTAL_LEAD_BUSINESS_DAYS = 3;

export function minRentalStartDate(businessDays = RENTAL_LEAD_BUSINESS_DAYS): string {
  const d = new Date();
  let remaining = businessDays;
  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) remaining--;
  }
  return d.toISOString().slice(0, 10);
}
